import { render, staticRenderFns } from "./DataMap.vue?vue&type=template&id=4d3977ab&"
import script from "./DataMap.vue?vue&type=script&lang=ts&"
export * from "./DataMap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports